import PropTypes from 'prop-types';
import cn from 'classnames';
import React from 'react';
import { isSelected } from 'react-big-calendar/lib/utils/selection';
import * as dates from 'react-big-calendar/lib/utils/dates';

import formatDate from 'Shared/util/formatDate';

class EventCell extends React.Component {
  render() {
    let {
      style,
      className,
      event,
      selected,
      isAllDay,
      onSelect,
      onDoubleClick,
      localizer,
      continuesPrior,
      continuesAfter,
      accessors,
      getters,
      children,
      components: { event: Event, eventWrapper: EventWrapper },
      slotStart,
      slotEnd,
      ...props
    } = this.props;

    let title = accessors.title(event);
    let tooltip = accessors.tooltip(event);
    let end = accessors.end(event);
    let start = accessors.start(event);
    let allDay = accessors.allDay(event);

    let showAsAllDay = isAllDay || allDay || dates.diff(start, dates.ceil(end, 'day'), 'day') > 1;

    let userProps = getters.eventProp(event, start, end, selected);

    const content = (
      <div className="rbc-event-content" title={tooltip || undefined}>
        {Event ? (
          <Event
            event={event}
            continuesPrior={continuesPrior}
            continuesAfter={continuesAfter}
            title={title}
            isAllDay={allDay}
            localizer={localizer}
            slotStart={slotStart}
            slotEnd={slotEnd}
          />
        ) : (
          title
        )}
      </div>
    );

    return (
      <EventWrapper {...this.props} type="date">
        <div
          {...props}
          style={{ ...userProps.style, ...style }}
          className={cn('rbc-event', className, userProps.className, {
            'rbc-selected': selected,
            'rbc-event-allday': showAsAllDay,
            'rbc-event-continues-prior': continuesPrior,
            'rbc-event-continues-after': continuesAfter,
            'event--holidays': event.type === 'Holidays',
            'event--vacation': event.type === 'Vacation',
            'event--sick-leave': event.type === 'Sick leave',
            'event--day-off': event.type === 'Day off',
          })}
        >
          {typeof children === 'function' ? children(content) : content}
          <div className="row__event-popup">
            <div
              className={cn('popup__header', {
                'popup__header--holidays': event.type === 'Holidays',
                'popup__header--vacation': event.type === 'Vacation',
                'popup__header--sick-leave': event.type === 'Sick leave',
                'popup__header--day-off': event.type === 'Day off',
              })}
            >
              {event.type}
            </div>
            <div className="popup__title">From</div>
            <div className="popup__text">{formatDate(event.start)}</div>
            <div className="popup__title">To</div>
            <div className="popup__text">{formatDate(event.end)}</div>
          </div>
        </div>
      </EventWrapper>
    );
  }
}

class CustomEventRow extends React.Component {
  renderEvent(props, event) {
    let { selected, accessors, getters, onSelect, onDoubleClick, localizer, slotMetrics, components } = props;

    let continuesPrior = slotMetrics.continuesPrior(event);
    let continuesAfter = slotMetrics.continuesAfter(event);

    return (
      <EventCell
        event={event}
        getters={getters}
        localizer={localizer}
        accessors={accessors}
        components={components}
        onSelect={onSelect}
        onDoubleClick={onDoubleClick}
        continuesPrior={continuesPrior}
        continuesAfter={continuesAfter}
        slotStart={slotMetrics.first}
        slotEnd={slotMetrics.last}
        selected={isSelected(event, selected)}
      />
    );
  }

  renderSpan(slots, len, key, content = ' ') {
    let amountOfDays = slots === 7 ? 7 : 31;
    let per = (Math.abs(len) / amountOfDays) * 100 + '%';
    return (
      <div
        key={key}
        className={cn('rbc-row-segment', 'event-container')}
        // IE10/11 need max-width. flex-basis doesn't respect box-sizing
        style={{ WebkitFlexBasis: per, flexBasis: per, maxWidth: per }}
      >
        {content}
      </div>
    );
  }

  render() {
    let {
      segments,
      slotMetrics: { slots },
      className,
    } = this.props;

    let lastEnd = 1;

    return (
      <div className={cn(className, 'rbc-row')}>
        {segments.reduce((row, { event, left, right, span }, li) => {
          let key = '_lvl_' + li;
          let gap = left - lastEnd;

          let content = this.renderEvent(this.props, event);

          if (gap) row.push(this.renderSpan(slots, gap, `${key}_gap`));

          row.push(this.renderSpan(slots, span, key, content));

          lastEnd = right + 1;

          return row;
        }, [])}
      </div>
    );
  }
}

CustomEventRow.propTypes = {
  segments: PropTypes.array,
};

export default CustomEventRow;
